import { transport } from "@/src/config/apiConfig.js";

export default {
  async fetchConfiguration() {
    try {
      let res = await transport.get(`/api/customer-success/configuration`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching customer success configuration: ",
        error,
      );
      throw error;
    }
  },

  async updateConfiguration(payload) {
    try {
      let res = await transport.put(
        `/api/customer-success/configuration`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating customer success configuration: ",
        error,
      );
      throw error;
    }
  },
};
